import useStore from "../AppStore"
import { motion, AnimatePresence } from 'framer-motion'
import { useProgress } from "@react-three/drei"

export default function Intro(props) {

  const lang = useStore(state => state.lang)
  const initial = useStore(state => state.initial)

  const { active, progress, errors, item, loaded, total } = useProgress()

  function enter(play){
    if(progress < 100) return
    useStore.setState({initial: false})
    if(play){
      props.play()
    }
  }

  return (
    <AnimatePresence exitBeforeEnter>
      {initial &&
      <motion.div
        className="intro"
        animate={{opacity: initial ? 1 : 0}}
      >
        <div className="intro--enter" onClick={()=>enter(true)}>
          {progress >= 100 &&
          <motion.span
            className="enter"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          ><span>{lang ? 'Entrar' : 'Enter'}</span></motion.span>
          }
          {progress < 100 &&
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >{Math.floor(progress)}%</motion.span>
          }
        </div>
        {progress >= 100 &&
        <motion.div
          className="intro--mute"
          onClick={()=>enter(false)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        ><span>{lang ? 'Continuar sem áudio' : 'Continue without sound'}</span></motion.div>
        }
      </motion.div>
      }
    </AnimatePresence>
  )
}